import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.boundAppendState = this.appendState.bind(this);
    this.element.addEventListener("click", this.boundAppendState);
  }

  disconnect() {
    if (this.boundAppendState) {
      this.element.removeEventListener("click", this.boundAppendState);
    }
  }

  appendState() {
    const openAccordion = document.querySelector(".accordion-collapse.show");
    if (!openAccordion) return;

    if (this.element.href) {
      const url = new URL(this.element.href, window.location.origin);
      url.searchParams.set("open_accordion_menu_id", openAccordion.id);
      this.element.href = url.toString();
    }
  }
}
